import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useParams } from 'react-router-dom';
import SaveIcon from '@material-ui/icons/Save';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import axios from 'axios';
import { add_agent } from '../../../../api/API';

const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },
    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));




// const classes = useStyles();
// const [openSnackbar, setOpenSnackbar] = useState(false);
// const [values, setValues] = useState({
//     firstName: profile.firstName,
//     lastName: profile.lastName,
//     email: profile.email,
//     phone: profile.phone,
//     state: profile.state,
//     country: profile.country,
//     isPublic: profile.isPublic,
//     canHire: profile.canHire
// });

export default class From extends React.Component {

    constructor(props) {

        super(props);
        let id = props.match.params.id;
        this.state = {
            agency: null,
            form: {
                values: {
                    password: '',
                    name: '',
                    email: '',
                    phone: '',
                    // agency_id: window.localStorage.getItem("role") == 'agency' ? window.localStorage.getItem("user_id") : ''
                    agency_id: id
                }
            },
            passwordError: false,
            passwordText: ""
        };
        const { profile, className, ...rest } = props;

    }


    async get_agency() {

    }

    checkPassword(password) {
        let check_length = new RegExp("(?=.{6,})");
        let check_number = new RegExp("(?=.*[0-9])");
        let check_special = new RegExp("(?:.*[!@#$%^&*()+\'\"]+.*)");

        if (!check_length.test(password)) {
            this.setState({
                ...this.state,
                passwordError: true,
                passwordText: "Password must be at least 6 characters or longer"
            });
            return false;
        }
        if (!check_number.test(password)) {
            this.setState({
                ...this.state,
                passwordError: true,
                passwordText: "Password must be at contain at least 1 number"
            });

            return false;
        }
        if (!check_special.test(password)) {
            this.setState({
                ...this.state,
                passwordError: true,
                passwordText: "Password must contain at least 1 special character"
            });
            return false;
        }
        this.setState({
            ...this.state,
            passwordError: false,
            passwordText: "All Good"
        });

        return true;
    }

    componentDidMount() {
        this.get_agency();
    }

    handleChange(event) {
        event.persist();
        if (event.target.name == 'password') {
            this.checkPassword(event.target.value)
        }


        this.setState({
            ...this.state,
            form: {
                values: {
                    ...this.state.form.values,
                    [event.target.name]: event.target.value
                }
            }
        });
    }

    async handleSubmit(event) {
        event.preventDefault();

        if(!this.checkPassword(this.state.form.values.password)){
            return;
        }
        if (
            this.state.form.values.password == "" ||
            this.state.form.values.password2 == "" ||
            this.state.form.values.email == "" ||
            this.state.form.values.contact == ""
        ) {
            alert("Please enter all fields");
            return;
        }
        if (this.state.form.values.password != this.state.form.values.password2) {
            alert("Passwords do not match");
            return;
        }
        var res = await add_agent(this.state.form.values);

        if (res.status) {
            this.props.history.push("/agency_admins/" + this.props.match.params.id);
        } else { 
            alert(res.message);
            return;
        }
    };

    handleSnackbarClose = () => {
        // setOpenSnackbar(false);
    };

    render() {


        return (
            <Card
                {...this.props.rest}
                className={clsx(this.props.classes.root, this.props.className)}
            >
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <CardHeader title="Create New Admin" />
                    <Divider />
                    <CardContent>

                        <Grid
                            container
                            spacing={4}
                        >
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Email Address"
                                    name="email"
                                    onChange={this.handleChange.bind(this)}
                                    required
                                    type="email"
                                    variant="outlined"
                                />
                            </Grid>

                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Name"
                                    name="name"
                                    onChange={this.handleChange.bind(this)}
                                    required
                                    type="text"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Contact"
                                    name="contact"
                                    onChange={this.handleChange.bind(this)}
                                    required
                                    type="text"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    helperText={this.state.passwordText}
                                    error={this.state.passwordError}
                                    type="password"
                                    label="Password"
                                    name="password"
                                    onChange={this.handleChange.bind(this)}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    type="password"
                                    label="Confirm Password"
                                    name="password2"
                                    onChange={this.handleChange.bind(this)}
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions className={this.props.classes.flexend}>
                        <Button
                            className={this.props.classes.saveButton}
                            type="submit"
                            variant="contained"

                        >
                            <SaveIcon className={this.props.classes.leftIcon} />
                            Save Changes
                </Button>
                    </CardActions>
                </form>
                {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
            </Card>
        )
    }
}

